'use client'

import React from 'react'
import Image from 'next/image'
import { ArrowUpRightIcon } from '@heroicons/react/24/outline'
import styles from './styles.module.css'
import { ArticleProps } from '@/widgets/landing-page-widgets/ArticleSection/schema'
import { Button, Typography } from '@pw-tech/omni-ui'

const Article = ({ article }: { article: ArticleProps }) => {
  const handleOpenArticle = () => {
    if (window && typeof window !== 'undefined') {
      window.open(article?.url)
    }
  }

  return (
    <div key={article?.url}>
      <div className={styles.article} tabIndex={0} role='button' onClick={handleOpenArticle}>
        <div className={styles.articleContainer}>
          <div className={styles.imageContainer}>
            {article?.thumbnail && (
              <Image
                src={article?.thumbnail}
                layout='responsive'
                height={180}
                width={280}
                objectFit='cover'
                alt='article-cover'
                loading='lazy'
              />
            )}
          </div>
          <div className={styles.contentContainer}>
            <div className={styles.textContainer}>
              <Typography variant='heading4' weight='bold' color='#1b2124'>
                {article.heading}
              </Typography>
              <Typography variant='small' className={styles.description} color='#3d3d3d'>
                {article.description}
              </Typography>
            </div>
            <div>
              <Button variant='link'>
                <Typography
                  component='span'
                  weight='semi-bold'
                  variant='small'
                  color='#3d3d3d'
                  className={styles.buttonContainer}
                >
                  View full story
                  <ArrowUpRightIcon
                    className={styles.arrowIcon}
                    width={14}
                    height={14}
                    fontWeight={600}
                    color='#3D3D3D'
                    strokeWidth={2}
                  />
                </Typography>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Article
